import {mapActions, mapGetters, mapMutations} from 'vuex';
import paginationMixin from '../../mixins/pagination/index.js'
import showPage from "../../mixins/showPage";

const _ = require('lodash')
export default {
    components:{
        Header: () => import('@/components/header/index.vue'),
        leftBar: () => import('@/components/left-bar/index.vue'),
        warehousePopup: () => import('../../components/popups/warehouse/index.vue'),
        pagination: () => import('../../components/pagination/index.vue'),
    },
    mixins: [paginationMixin, showPage],
    data(){
        return{
            pageId:24,
            productSearch:{
                id:'',
                title:''
            },
            fields:[
                {
                    key: 'id',
                    label: 'ID'
                },
                {
                    key: 'title',
                    label:  this.$t('tables.title')
                },
                {
                    key: 'product_count',
                    label:  this.$t('tables.count')
                }
            ],
            items:[],
            showWarehousePopup: false,
            selectedItem: null,
            sort:false
        }
    },
    computed: {
        ...mapGetters({
            menuHide:'config/menuHide',
            warehouses:'warehouse/warehouses',
            warehousesProducts:'warehouse/warehousesProducts',
        })
    },
    watch:{
        warehouses(e){
            this.selectedItem = e.data[0].id
        },
        warehousesProducts(e){
            this.items = []
            e.data.map(item=>{
                this.items.push({'title': item.title, id:item.id, product_count: item.sum_quantity});
            })
            this.res = e
        },
        page() {
            this.searchWarehouseProduct()
        },
        per_page() {
            this.searchWarehouseProduct()
        }
    },
    created() {
        this.toggleLoadingStatus(true);
        this.getWarehouses({page: 1, per_page: this.per_page}).then(()=>{
            this.toggleLoadingStatus(false);
        });
    },
    methods:{
        findForId: _.debounce(function(){
            this.searchWarehouseProduct();
        },600),
        findForTitle: _.debounce(function(){
            this.searchWarehouseProduct();
        },600),
        searchWarehouseProduct(){
            let searchLink = '';
            if(this.productSearch.id){
                searchLink +=  '&id='+this.productSearch.id
            }
            if(this.productSearch.title){
                searchLink +=  '&title='+this.productSearch.title
            }
            this.getWarehousesProducts({id:this.selectedItem, page: this.page, per_page: this.per_page, links: searchLink})
        },
        sortWarehouseProducts(){
            const sort = this.sort ? '&sort=DESC' : "&sort=ASC"
            this.getWarehousesProducts({id:this.selectedItem, page: this.page, per_page: this.per_page, links:sort,});
            this.sort = !this.sort;
        },
        findWarehouseProducts(){
            console.log('this.selectedItem - ', this.selectedItem )
            this.getWarehousesProducts({id:this.selectedItem, page: 1, per_page: this.per_page})
        },
        ...mapActions({
            getWarehouses:'warehouse/getWarehouses',
            getWarehousesProducts:'warehouse/getWarehousesProducts',
        }),
        ...mapMutations({
            toggleLoadingStatus: 'config/toggleLoadingStatus',
        })
    }
}
